<template>
  <v-container fluid class="department-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex flex-start justify-md-start">
              <v-btn to="/department/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="departments-table"
              show-select
              single-select
              item-key="_id"
              sort-by="departmentname"
              :footer-props="footer"
              :headers="headers"
              :items="departments"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Department?
                    </v-card-title>

                    <v-card-text>
                      {{ deleteDepartment.departmentname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteDepartment)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.image="{ item }">
                <v-avatar v-if="item.departmentimage" size="35">
                  <img v-bind:src="item.departmentimage" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="35">
                  <span class="white--text headline">{{ item.departmentname[0].toUpperCase() }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.departmentname="{ item }">
                <a class="primaryConst--text">{{ item.departmentname }}</a>
              </template>
              <template v-slot:item.departmentemail="{ item }">
                <a class="primaryConst--text">{{ item.departmentemail }}</a>
              </template>
              <template v-slot:item.departmentid="{ item }">
                {{ item.departmentid }}
              </template>
              <template v-slot:item.company>
                Flatlogic
              </template>
              <template v-slot:item.departmentstatus="{ item }">
                <v-chip
                  :color="!item.departmentstatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.departmentstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import mock from "./mock"
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'departmentList',
  data() {
    return {
      mock,
      config,
      snackbar: null,
      dialog: false,
      deleteDepartment: {},
      headers: [
        { text: 'Image', value: 'image', sortable: false },
        { text: 'Type', value: 'departmenttype' },
        { text: 'Name', value: 'departmentname' },
        { text: 'Code', value: 'departmentcode' },
        { text: 'Status', value: 'departmentstatus' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      switch1: true,
      departmentid: ['admin', 'department'],
      editedIndex: -1,
      editedItem: {
        departmentname: '',
        image: '',
        departmentid: '',
        company: '',
        departmenttype: '',
        departmentstatus: '',
        create: '',
      },
      defaultItem: {
        departmentname: '',
        image: '',
        departmentid: '',
        company: '',
        departmenttype: '',
        departmentstatus: '',
        create: '',
      },
      images: [
        require('@/assets/img/user/avatars/1.png'),
        require('@/assets/img/user/avatars/2.png'),
        require('@/assets/img/user/avatars/3.png'),
        require('@/assets/img/user/avatars/4.png'),
        require('@/assets/img/user/avatars/5.png'),
      ],
      
      text: '',
      //notification: '<p class="font-weight-bold mb-0">This page is only available in Vue Material Admin Full with ' +
      //    '<a rel="noreferrer noopener" target="_blank" class="white--text text-decoration-none" href="https://flatlogic.com/templates/sing-app-vue-node-js">NodeJS</a>/' +
      //    '<a rel="noreferrer noopener" target="_blank" class="white--text text-decoration-none" href="https://flatlogic.com/templates/sing-app-vue-laravel">PHP</a> backend integration!</p>'
    }
  },

  computed: {
    ...mapState('Department', ['departments', 'isReceiving', 'isDeleting', 'idToDelete', 'departmentsMessage', 'isUpdating']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit department'
    },
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    departmentsMessage() {
      this.notification = this.departmentsMessage;
      this.addSuccessNotification()
    }
  },
  created () {
    this.getDepartmentsRequest()
    this.addSuccessNotification()
  },

  methods: {
    ...mapActions('Department', [
      "getDepartmentsRequest",
      "deleteDepartmentRequest",
      "updateDepartmentRequest",
      "createDepartmentRequest"
    ]),

    editItem(item) {
      this.$router.push({ name: 'DepartmentEdit', params: item })
    },

    deleteItem(item) {
      console.log(item);
      //const pos = this.departments.map(function(department) { return department._id; }).indexOf(item._id);
      //this.departments.splice(pos, 1);
      this.deleteDepartmentRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteDepartment = {
        _id: item._id,
        departmentname: item.departmentname,
      }
    },
    close () {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1
      })
    },

    save () {
      if (this.editedIndex > -1) {
        !config.isBackend ?
        Object.assign(this.departments[this.editedIndex], this.editedItem)
        :
        this.updateDepartmentRequest(this.editedItem)
      } else {
        !config.isBackend ?
        this.departments.push(this.editedItem)
        :
        this.createDepartmentRequest(this.editedItem)
      }
      this.close()
    },

    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
